import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppConfigService} from '../common/service/mpvAppConfigService';
import {HttpApiService} from '../common/service/mpvHttpApiService';
import {SigedCommonService} from '../siged-common.service';
import {AuthService} from './auth.service';
import {Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})

export class ArchivoService {

  private defaultHeaders;

  constructor(
      public httpApiService: HttpApiService,
      public appConfigService: AppConfigService,
      public mpvCommonService: SigedCommonService,
      private http: HttpClient,
      authService: AuthService,
  ) {
    this.defaultHeaders = {
      Authorization: 'Bearer ' + authService.getUser()
    }
  }

  baseUrl = this.mpvCommonService.APPLICATION_API_HOST + "/";

  agregarArchivo2(parametro): any {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        '/archivo/upload',
        parametro
    );
  }

  getByIdArchivo(idArchivo): any {
    return this.httpApiService.get(
        this.mpvCommonService.APPLICATION_API_HOST,
        '/archivo/' + idArchivo
    )
  }

  anuladosPorDocumento(
      params: HttpParams | { idDocumento: string, personaBandeja: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}archivo/anuladosPorDocumento`, options).toPromise();
  }

  obtenerTrazabilidadGeneral(
      params: { idExpediente: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}archivo/obtenerTrazabilidadGeneral`, options).toPromise();
  }

  asociarArchivoAlfresco(idTramiteVirtual, idArchivoAlfresco, nombreArchivo): any {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        '/archivo/asociar', {
          'idTramiteVirtual': idTramiteVirtual,
          'idArchivoAlfresco': idArchivoAlfresco,
          'nombreArchivo': nombreArchivo
        }
    )
  }

  validarArchivoCarga(
      data: {
        'idDocumento': string,
        'nombreArchivo': string,
        'personaBandeja': string
      }
  ): any {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        '/archivo/validarArchivoCarga', data
    )
  }

  insertarArchivo(
      data: {
        "nombre": string,
        "uuid": string,
        "idDocumento": string,
        "personaBandeja": string,
        "esPrincipal"?: number
      }
  ): Promise<any> {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        "/archivo/insertarArchivo", data)
  }
  validarArchivoDocumental(
      data: {
          idDocumentoArchivo: any,
          nombreArchivo: any
      }
  ): Promise<any> {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        "/archivoDocumental/validarArchivoCarga", data)
  }

  insertarArchivo2(
      data: any
  ): any {
    return this.httpApiService.post(
        this.mpvCommonService.APPLICATION_API_HOST,
        '/archivo/insertarArchivo', data
    )
  }

  getUrl(uuid): Promise<any> {
    return this.httpApiService.get(
        this.baseUrl,
        'alfresco/download/' + uuid + '?d=' + new Date().getTime(), {}
    );
  }

  getPreviewDoc(uuid): Promise<any> {
    return this.httpApiService.get(
        this.baseUrl,
        'alfresco/preview/' + uuid + '?d=' + new Date().getTime(), {}
    );
  }

  getUrlAlfrescoArchivo(uuid): Promise<any> {
    return this.httpApiService.get(
        this.baseUrl,
        'alfresco/downloadAlfrescoArchivo/' + uuid + '?d=' + new Date().getTime(), {}
    );
  }

  getUrlMPV(uuid): Promise<any> {
    return this.httpApiService.get(
      this.baseUrl,
      'alfresco/downloadMPV/' + uuid + '?d=' + new Date().getTime(), {}
    );
  }

  recuperar(
      params: HttpParams | { [param: string]: string | string[] },
      body: any,
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}archivo/recuperar`, body, options).toPromise();
  }

  esPrincipal(
      idArchivo: string,
      body?: { [param: string]: string | string[] },
      params?: HttpParams | { [param: string]: string | string[] },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.post(`${this.baseUrl}archivo/principal/${idArchivo}`, body, options).toPromise();
  }

  verificarArchivoAnular(
      params: { idArchivo: string, usuarioBandeja: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}archivo/verificarArchivoAnular`, options).toPromise()
  }

  VersionArchivoAnular(
      params: { idArchivo: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}archivo/eliminarVersion`, options).toPromise();
  }

  EliminarArchivoAnular(
      params: { idArchivo: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options = {params, headers: {...this.defaultHeaders, ...headers}}
    return this.http.get(`${this.baseUrl}archivo/eliminarArchivo`, options).toPromise();
  }

  DescargarZipDocumento(
      params: { idDocumento: string },
      headers?: HttpHeaders | { [header: string]: string | string[]; }
  ) {
    const options: any = { params, headers: { ... this.defaultHeaders, ...headers }, responseType: 'blob' };
    return this.http.get(`${this.baseUrl}archivo/zipDocumento`, options);
  }

    getAlfrescoUploadParams(fileName: string): Promise<any> {
        const params = { fileName };
        const options = { params, headers: { ...this.defaultHeaders }};
        return this.http.post(`${this.baseUrl}alfresco/getAlfrescoUploadParams`, null, options).toPromise();
    }

    findFileByName(fileName): Observable<any> {
        const options = { params: {fileName}, headers: { ...this.defaultHeaders } };
        return this.http.post(`${this.baseUrl}alfresco/findFileByName`, null, options);
    }

    insertarArchivoMensajeria(
        body: { idDocumento: any, idMensajeria: any, nombre: string, uuid: string}
    ) {
      const options = { headers: { ...this.defaultHeaders } };
      return this.http.post(`${this.baseUrl}archivo/insertarArchivoMensajeria`, body, options).toPromise();
    }

    uploadFileAlfresco(formData: FormData, url) {
      return this.http.post<any>(url, formData);
    }
}
